import { Component, OnDestroy, OnInit } from '@angular/core';
import { SegovSigepoPortalBodyComponent } from '../../controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from '../../controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { AtendimentoCardComponent, EnumEmphasis } from './sub-views/atendimento-card/atendimento-card.component';
import { CommonModule } from '@angular/common';
import { EnviarEmailContatoComponent } from './sub-views/enviar-email-contato/enviar-email-contato.component';
import { ControlsModule } from "segov-sigepo-lib";
import { Store } from '@ngrx/store';
import { ObterDadosContatosState } from 'src/app/stateManagement/reducers/obter-dados-contatos.reducer';
import { obterDadosContatos } from 'src/app/stateManagement/actions/obter-dados-contatos.action';
import { selectObterDadosContatos } from 'src/app/stateManagement/selectors/obter-dados-contatos.selector';
import { filter, map, Subscription } from 'rxjs';
import { SegovPage } from 'src/app/app.routes';
import { ComponentMessages } from 'src/app/utils/component.messages';
import { Router } from '@angular/router';
import { CommonConverter } from 'src/app/utils/common.converter';

@Component({
  selector: 'app-fale-conosco-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    EnviarEmailContatoComponent,
    AtendimentoCardComponent,
    ControlsModule,
    CommonModule
  ],
  templateUrl: './fale-conosco-page.component.html',
  styleUrl: './fale-conosco-page.component.css'
})
export class FaleConoscoPageComponent implements OnInit, OnDestroy {
  public titulo = ComponentMessages.centralDeRelacionamento;

  public colunaAtendimento: Card[];
  public colunaAjuda: Card[];
  public cardEndereco: Card;

  private subDadosContrato: Subscription = new Subscription();
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Atendimento", route: SegovPage.Atendimento },
    { title: "Canais de contato", route: SegovPage.Atendimento}
  ]
  public cardCanalMensagens: Card;

  constructor(
    private DadosContatosStore: Store<{ obterDadosContatosState: ObterDadosContatosState }>,
    private router: Router
  ) {
    this.colunaAtendimento = [
      {
        titulo: "",
        emphasis: EnumEmphasis.WithEmphasis,
        topico: "Por WhatsApp ou Telefone",
        icons: ["phone-line.svg"],
        descricao: "Número para atendimento via ligação e WhatsApp.\nAtendimento nos dias úteis das 8h às 18h."
      },
      {
        titulo: "",
        emphasis: EnumEmphasis.WithEmphasis,
        topico: "Por e-mail",
        icons: ["mail-outline.svg"],
        descricao: "Endereço para envio de e-mail."
      },
      {
        titulo: "Dias úteis | 8 às 18 horas",
        emphasis: EnumEmphasis.WithEmphasis,
        topico: "Horários",
        icons: ["calendar-clock.svg"],
        descricao: "Período de atendimento"
      }
    ];

    this.colunaAjuda = [
      {
        titulo: "Tire suas dúvidas",
        emphasis: EnumEmphasis.WithEmphasis,
        icons: ["question-line.svg"],
        descricao: "Acesse as perguntas frequentes sobre o diário oficial. Contatos, Cadastro, Publicações, Autenticidade, Contrato Gratuidade, Receita, Pesquisa, Direitos autorais e Ressarcimento",
        buttonName: "Perguntas frequentes",
        rota: SegovPage.PerguntasFrequentes
      },
      {
        titulo: "Confira as datas de publicações",
        emphasis: EnumEmphasis.WithEmphasis,
        icons: ["bx-calendar.svg"],
        descricao: "Confira o calendário de Publicações do Diário Oficial Eletrônico Minas Gerais e fique por dentro das datas de feriados e pontos facultativos e a programação das publicações nestes dias.",
        buttonName: "Acesse o calendário",
        rota: SegovPage.CalendarioPublicacao
      },
      {
        titulo: "Ouvidoria Geral do Estado",
        emphasis: EnumEmphasis.WithEmphasis,
        icons: ["sound-line.svg"],
        descricao: "O governo de Minas Gerais disponibiliza um canal de Ouvidoria-Geral para todos os serviços do estado. Caso tenha algo em relação ao nosso serviço de publicação pode acionar esse canal.",
        buttonName: "Acesse a ouvidoria",
        rotaExterna: 'https://www.ouvidoriageral.mg.gov.br/'
      }
    ];

    this.cardEndereco = {
      titulo: "Cidade Administrativa de Minas Gerais",
      topico: "Funcionamento",
      emphasis: EnumEmphasis.WithEmphasis,
      icons: ["map-mail.svg"],
      descricao: "Superintendência de Gestão do Diário Oficial\nSecretaria de Estado de Governo\nRodovia Papa João Paulo II, 4.000\nEdificio Gerais, 1º andar\nBairro Serra Verde\nBH / MG\nCEP:31630-901",
      buttonName: "Como chegar"
    };

    this.cardCanalMensagens = {
      titulo: "Canal de mensagens no whatsapp",
      topico: "Receba atualizações em primeira mão",
      emphasis: EnumEmphasis.WithEmphasis,
      icons: ["cellphone-chat.svg"],
      buttonName: "Acesse aqui",
      descricao: '',
      rotaExterna: 'https://whatsapp.com/channel/0029VaZ8Ajb4NVifmreetw3Z'
    };
  }

  ngOnInit(): void {
    this.DadosContatosStore.dispatch(obterDadosContatos());

    this.subDadosContrato = this.DadosContatosStore.select(selectObterDadosContatos).pipe(
      filter(state => state !== null && state.dados !== null),
      map(state =>
        state?.dados
      )
    ).subscribe(x => {
      this.colunaAtendimento[0].titulo = x?.telefones.map(x => `<a style='color: inherit; text-decoration: none;' target='_blank' rel='noopener noreferrer' href="https://wa.me/${CommonConverter.removeSpecialCharacters(x)}">${x}</a>`).join(" ou ") ?? "";
      this.colunaAtendimento[1].titulo = `<a style='color: inherit; text-decoration: none;' target='_blank' rel='noopener noreferrer' href="mailto:${x?.email}">${x?.email}</a>`
    }
    );
  }

  ngOnDestroy(): void {
    this.subDadosContrato.unsubscribe();
  }

  public goToPage(card?: Card) {
    if (card?.rota)
      this.router.navigate([card.rota])
    else if (card?.rotaExterna) {
      window.open(card.rotaExterna, '_blank')
    }
  }
}

interface Card {
  topico?: string;
  emphasis?: EnumEmphasis;
  titulo: string;
  descricao: string;
  icons: string[];
  buttonName?: string;
  rota?: string,
  rotaExterna?: string
}
